const OpportunitiesFilterParams = {
  ageInDays: {
    type: Date,
    isDefault: true,
  },
  askAmount: {
    type: Number,
  },
  confidence: {
    type: Number,
  },
  expectedAmount: {
    type: Number,
  },
  projected: {
    type: Number,
  },
  stage: {
    type: Date,
  },
} as const;

export default OpportunitiesFilterParams;
